var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#df3079",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M2 30L30 2m0 28L2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.72c73189c1a7586396a5ae1e9e6556c6.svg";
export { ForwardRef as ReactComponent };